import React, { useState } from "react";
import "./ContactUs.css";
import { toast } from "react-toastify";
import Header from "../../components/header";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    toast.success("Thank you for contacting us!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <>
          <Header  hideSearchBar={true} />
    <div className="contactus-container">
      <div className="contactus-content">
        <h1 className="contactus-title">Contact Us</h1>
        <p className="contactus-description">
          Have a question, feedback, or partnership inquiry? We'd love to hear
          from you! Fill out the form below and our team will get back to you
          shortly.
        </p>

        <form className="contactus-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="6"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <button type="submit" className="contactus-button">
            Send Message
          </button>
        </form>
      </div>
    </div>
    </>
  );
};

export default ContactUs;
